module.exports = __webpack_public_path__ + "media/2.e71e371e.mp3";